import { useCallback, useEffect, useRef } from "react";
import { setQuestionSize } from "@formsort/custom-question-api";

export const useCustomQuestionAutoheight = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    container.scrollIntoView({ block: "start" });

    const resizeObserver = new ResizeObserver(() => {
      setQuestionSize(undefined, container.offsetHeight);
    });
    resizeObserver.observe(container);

    return () => {
      return resizeObserver.disconnect();
    };
  }, []);

  const scrollToTop = useCallback(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    containerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return { containerRef, scrollToTop };
};
